export const zakelijkDoorCodes = [
  "kaderdeur",
  "dubbelekaderdeur",
  "zakelijkkozijn",
  "profiel",
  "zakelijkkozijnglas",
  "zakelijkkozijndubbelglas",
];

export const zakelijkProfielCodes = ["profiel"];

export const zakelijkKozijnCodes = ["zakelijkkozijn"];
